<template>
    <div>
        <hint :title="$t('notifications.sent.title')" class="mt-8">
            {{ $t('notifications.sent.body') }}
        </hint>
        <div class="flex flex-row-reverse items-start justify-between mt-8">
            <div @click="navigateToHome" class="bg-primary text-white px-4 py-2 flex flex-row items-center uppercase font-bold tracking-wide cursor-pointer select-none">
                {{ $t('commons.back-home') }}
            </div>
        </div>
    </div>
</template>

<script>
import Hint from '@/components/Hint'

export default {
    components: { Hint },
    methods: {
        navigateToHome() {
            window.top.location.href = '/'
        },
    }
}
</script>